import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const snapchat = defineConnector({
  identifier: "snapchat",
  name: "Snapchat",
  tagLine: "Social media and advertising",
  logo,
  protocol: "http",
  tags: ["productivity", "communication"],
  defaultUrlPattern: () => "https://adsapi\\.snapchat\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Snapchat app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Snap Kit Developer Portal](https://kit.snapchat.com/manage/) and create a new app. Enable the APIs you need, then find your OAuth2 client ID and secret under your app's settings.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/snapchat/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Snapchat account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Snapchat account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://accounts.snapchat.com/login/oauth2/authorize",
    tokenEndpoint: () =>
      "https://accounts.snapchat.com/login/oauth2/access_token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://adsapi.snapchat.com/v1/me",
  },
});
